export type MicrosoftDeployTarget = "dev" | "staging" | "prod";

/** Same tenant as commercial-frontend. Public SPA client ids, one per web environment. */
const MICROSOFT_SSO_TENANT_ID = "5ac68764-d64c-445c-88e1-3a3aaf2e0f0b";

const MICROSOFT_SSO_CLIENT_IDS: Record<MicrosoftDeployTarget, string> = {
  dev: "795e1789-15dd-4045-8d08-68dd488c317b",
  staging: "aa30ffd9-1426-4cf8-a092-f164680a64db",
  prod: "62dc5ae6-3dbe-4856-8ed9-fce2f7c87cee"
};

export type MicrosoftSsoSettings = {
  enabled: boolean;
  clientId: string;
  tenantId: string;
};

export function resolveMicrosoftSsoSettings(options: {
  deployTarget: MicrosoftDeployTarget;
  devServer: boolean;
  enabled?: string;
  clientId?: string;
  tenantId?: string;
}): MicrosoftSsoSettings {
  const target = options.devServer ? "dev" : options.deployTarget;
  const enabledRaw = options.enabled?.trim();
  return {
    enabled: enabledRaw !== "false",
    clientId: options.clientId?.trim() || MICROSOFT_SSO_CLIENT_IDS[target],
    tenantId: options.tenantId?.trim() || MICROSOFT_SSO_TENANT_ID
  };
}
